import { render, staticRenderFns } from "./waitPopup.vue?vue&type=template&id=b329edb0&scoped=true"
import script from "./waitPopup.vue?vue&type=script&lang=js"
export * from "./waitPopup.vue?vue&type=script&lang=js"
import style0 from "./waitPopup.vue?vue&type=style&index=0&id=b329edb0&prod&lang=scss&scoped=true"
import style1 from "./waitPopup.vue?vue&type=style&index=1&id=b329edb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b329edb0",
  null
  
)

export default component.exports